export default {
  mounted() {
    this.handleEvent("analytics:track", ({event, properties}) => {
      if (window.jitsu) window.jitsu("track", event, properties)
    })
    this.handleEvent("analytics:identify", ({user_id, traits}) => {
      if (window.jitsu) window.jitsu("id", {id: user_id, ...traits})
    })
    this.handleEvent("analytics:page", ({properties}) => {
      if (window.jitsu) window.jitsu("page", properties)
    })
  }
}
